export default new Map([
    ["ADMINISTRATOR", 1n << 0n],
    ["MANAGE_CHANNELS", 1n << 1n],
    ["MANAGE_ROLES", 1n << 2n],
    ["MANAGE_TEAM", 1n << 3n],
    ["VIEW_AUDIT_LOG", 1n << 4n],
    ["BAN_MEMBERS", 1n << 5n],
    ["DELETE_MESSAGES", 1n << 6n],
    ["MANAGE_APPLICATIONS", 1n << 7n],
    ["JOIN_TOURNAMENTS", 1n << 8n],
    ["CREATE_INVITES", 1n << 9n],
]);
